import { Component, OnInit } from '@angular/core';
import { EmpleadosServicio } from '../../services/empleado.service';
import { Router } from '@angular/router';

const ID_PAGINA = 28;

@Component({
  selector: 'app-configuraciones',
  templateUrl: './configuraciones.component.html',
  styleUrls: ['./configuraciones.component.css']
})
export class ConfiguracionesComponent implements OnInit {
  loaded = true;
  constructor(private empleadoService: EmpleadosServicio, private router: Router) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/configuraciones/configuraciones.component.ts